import cn from 'classnames';
import {useEffect, useState} from 'react';
import FullScreenIcon from 'infrastructure/assets/svg/full-screen.svg';
import FullScreenExitIcon from 'infrastructure/assets/svg/full-screen-exit.svg';

import './fullScreenToggle.scss';


export default function FullScreenToggle ({
                                            id,
                                            label,
                                            className,
                                            ...other
                                          }) {

  const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);
  useEffect(() => {

    function onFullscreenChange(e) {
      setIsFullscreen(!!document.fullscreenElement);
    }

    document.addEventListener('fullscreenchange', onFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', onFullscreenChange);
    }
  }, []);


  const enterFullscreen = async () => {
    try {
      await document.body?.requestFullscreen();
      setIsFullscreen(true);
    } catch (err) {
      console.log('Failed to request fullscreen mode ', err);
    }
  };

  const exitFullscreen = async () => {
    try {
      await document.exitFullscreen();
      setIsFullscreen(false);
    } catch (err) {
      console.log('Failed to request exitFullscreen mode ', err);
    }
  };

  const toggleScreenMode = () => {
    document.fullscreenElement ? exitFullscreen() : enterFullscreen();
  };

    return (
      <div
        {...other}
        id={id}
        className={cn('mobile-header-item', className ?? '')}
        onClick={toggleScreenMode}
      >
        {isFullscreen ? <FullScreenExitIcon/> : <FullScreenIcon/>} {label ?? ''}
      </div>
    );
}

FullScreenToggle.propTypes = {
}
